module.exports = __webpack_public_path__ + "c5dd0c8748829069da58eb7c464d2f70.svg";